import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';

import {catchError, map, Observable, throwError} from 'rxjs';
import {AppConfigurationService} from '../../../erp/services/base/appConfiguration.service';

@Injectable({
  providedIn: 'root',
})
export class BeneficiarioPropostaSerice {
  constructor(
    private httpClient: HttpClient,
    private appConfigurationService: AppConfigurationService,
  ) {}

  buscarPropostaPorId(idProposta: string): Observable<any> {
    return this.httpClient
      .get<any>(`${this.appConfigurationService.apiBaseUrl}/Proposal?id=${idProposta}`)

      .pipe(
        map(response => {
          return response;
        }),
        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }

  // O valor default 'false' garante que, se não for passado, ele assuma false.
  cadastrarDadosBancario(data: any, ehColaborador: boolean = false): Observable<any> {
    let url = `${this.appConfigurationService.apiBaseUrl}/Proposal/${data.proposalId}/BankDetails`;

    if (ehColaborador) {
      url += `?isColaborator=${ehColaborador}`;
    }
    return this.httpClient.post<any>(url, data).pipe(
      map(response => {
        return response;
      }),

      catchError(err => {
        return throwError(() => ({
          message: err.message,
          status: err.status,
        }));
      }),
    );
  }

  buscarDadosBancarioPorPropostaPorId(idProposta: string): Observable<any> {
    return this.httpClient
      .get<any>(`${this.appConfigurationService.apiBaseUrl}/Proposal?id=${idProposta}`)

      .pipe(
        map(response => {
          return response;
        }),
        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }

  dadosEnderecoPorProposta(idProposta: string | undefined): Observable<any> {
    return this.httpClient
      .get<any>(`${this.appConfigurationService.apiBaseUrl}/Proposal/${idProposta}/AddressData/`)
      .pipe(
        map(response => {
          return response;
        }),
        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }

  buscarDadosBancarioPorProposta(idProposta: string | undefined): Observable<any> {
    return this.httpClient
      .get<any>(`${this.appConfigurationService.apiBaseUrl}/Proposal/${idProposta}/BankDetails/`)
      .pipe(
        map(response => {
          return response;
        }),
        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }

  assinarModaisAditivos(data: any): Observable<any> {
    return this.httpClient
      .post<any>(`${this.appConfigurationService.apiBaseUrl}/Proposal/AdditiveSignature`, data)
      .pipe(
        map(response => {
          return response;
        }),
        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }

  associarOperadora(proposalId: string, holderProposalId: string, isAssociate: boolean): Observable<any> {
    return this.httpClient
      .post<any>(
        `${this.appConfigurationService.apiBaseUrl}/Proposal/IsAssociate?proposalId=${proposalId}&holderProposalId=${holderProposalId}&isAssociate=${isAssociate}`,
        {},
      )
      .pipe(
        map(response => {
          return response;
        }),
        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }

  atualizarStep(proposalId: string, step: number): Observable<any> {
    return this.httpClient
      .put<any>(
        `${this.appConfigurationService.apiBaseUrl}/Proposal/UpdateStep?proposalId=${proposalId}&step=${step}`,
        {},
      )
      .pipe(
        map(response => {
          return response;
        }),

        catchError(err => {
          return throwError(() => new Error(err));
        }),
      );
  }
}
